import { Device } from '../../createDevice/redux/action';

export enum ApproveDeviceActionTypes {
  APPROVE_DEVICE_REQUEST = 'APPROVE_DEVICE_REQUEST',
  APPROVE_DEVICE_SUCCEEDED = 'APPROVE_DEVICE_SUCCEEDED',
  APPROVE_DEVICE_FAILED = 'APPROVE_DEVICE_FAILED',
  RESET_APPROVE_DEVICE = 'RESET_APPROVE_DEVICE',
}

export interface ApproveDeviceRequest {
  type: ApproveDeviceActionTypes.APPROVE_DEVICE_REQUEST;
  input: object;
}

export interface ApproveDeviceSucceeded {
  type: ApproveDeviceActionTypes.APPROVE_DEVICE_SUCCEEDED;
  device: Device;
}

export interface ApproveDeviceFailed {
  type: ApproveDeviceActionTypes.APPROVE_DEVICE_FAILED;
  error: Error;
}

export interface ResetApproveDevice {
  type: ApproveDeviceActionTypes.RESET_APPROVE_DEVICE;
}
export type ApproveDeviceActions =
  | ApproveDeviceRequest
  | ApproveDeviceSucceeded
  | ApproveDeviceFailed
  | ResetApproveDevice;

export function approveDeviceRequest(input): ApproveDeviceRequest {
  return {
    type: ApproveDeviceActionTypes.APPROVE_DEVICE_REQUEST,
    input,
  };
}

export function approveDeviceSucceeded(device): ApproveDeviceSucceeded {
  return {
    type: ApproveDeviceActionTypes.APPROVE_DEVICE_SUCCEEDED,
    device,
  };
}

export function approveDeviceFailed(error: Error): ApproveDeviceFailed {
  return {
    type: ApproveDeviceActionTypes.APPROVE_DEVICE_FAILED,
    error: error,
  };
}

export function resetApproveDevice(): ResetApproveDevice {
  return {
    type: ApproveDeviceActionTypes.RESET_APPROVE_DEVICE,
  };
}
